import { subscribe } from '../utils/pubsub'

type StartProcessInstanceArgs = {
    processId: string
    sendMessageToWebsocket: (payload: string) => void
    setShowModal: (modal: any) => void
    navigate: (path: string) => void
    loadingText: string
}

// starts a new instance of a process and navigates to it once the backend confirms - shared by
// every entry point that can trigger a start (the process list, the QR-scanned process page, and
// the in-process "start" screen) so they all resolve the destination route the same way
export function startProcessInstance({
    processId,
    sendMessageToWebsocket,
    setShowModal,
    navigate,
    loadingText,
}: StartProcessInstanceArgs) {
    setShowModal({ spinner: loadingText })
    const payload = JSON.stringify({
        action: 'processesClient',
        subAction: 'startProcess',
        Id: processId,
    })

    const unsubscribeUpdate = subscribe('processStarted', (data: any) => {
        if (data && data.Id === processId) {
            setShowModal(null)
            if (data.nextChecklistPeriod) {
                navigate(`/checklists/${data.nextChecklistPeriod}`)
            } else if (data.processRecordId) {
                navigate(`/process/${processId}/record/${data.processRecordId}`)
            } else {
                navigate(`/process/${processId}`)
            }
        }
        unsubscribeUpdate()
    })
    sendMessageToWebsocket(payload)
}
